/* UserPassword.js */

import React, { useCallback, useState } from 'react';
import { Label, FormGroup, Row, Col } from 'reactstrap';
import WAM from '../../services/WAM';
import { useAuth } from '../../context/auth/AuthContext';
import Strings from '../../translations/Translations';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import Button1 from '../buttons/Button1';

export default function UserPassword () {
  const { authenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const { register, formState: { errors }, handleSubmit, getValues, setValue } = useForm();

  const onSubmit = useCallback(async ({ current_password, new_password }) => {
    if (current_password && new_password) {
      setLoading(true);
      try {
        const response = await WAM.changeUserPassword(authenticated.un, authenticated.al, current_password, new_password);
        if (response && response.result === 'success') {
          toast.success(Strings('password_changed'));
          setValue('current_password', '');
          setValue('new_password', '');
          setValue('confirm_new_password', '');
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_update');
          toast.error(message);
        }
      } catch (err) {
        toast.error(Strings('general_error'));
      }
      setLoading(false);
    }
  }, [setLoading, authenticated, setValue]);

  return (
    <Row>
      <Col sm={12} className='mb-1'>
        <h2 className='h5'>
          {Strings('change_password')}
        </h2>
      </Col>

      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('current_password')}</Label>
          <input
            type='password'
            className='form-control shadow pb-input-1'
            name='current_password'
            {...register('current_password', { required: true })}
          />
          {errors && errors.current_password && errors.current_password.type === 'required' && (
            <p role='alert' className='text-danger txt-small-1'>{Strings('password_is_required')}</p>
          )}
        </FormGroup>
      </Col>
      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('new_password')}</Label>
          <input
            type='password'
            className='form-control shadow pb-input-1'
            name='new_password'
            {...register('new_password', { required: true })}
          />
          {errors && errors.new_password && errors.new_password.type === 'required' && (
            <p role='alert' className='text-danger txt-small-1'>{Strings('new_password_is_required')}</p>
          )}
        </FormGroup>
      </Col>
      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('confirm_new_password')}</Label>
          <input
            type='password'
            className='form-control shadow pb-input-1'
            name='confirm_new_password'
            {...register('confirm_new_password', {
              required: true,
              validate: (value) => {
                const new_password = getValues('new_password');
                return new_password === value;
              }
            })}
          />
          {errors && errors.confirm_new_password && errors.confirm_new_password.type === 'required' && (
            <p role='alert' className='text-danger txt-small-1'>{Strings('confirm_password_is_required')}</p>
          )}
          {errors && errors.confirm_new_password && errors.confirm_new_password.type === 'validate' && (
            <p role='alert' className='text-danger txt-small-1'>{Strings('passwords_must_match')}</p>
          )}
        </FormGroup>
      </Col>
      <Col sm={12}>
        <Button1
          size='lg'
          className='pb-btn-1'
          onClick={handleSubmit(onSubmit)}
          loading={loading}
          disabled={loading}
        >
          {Strings('save')}
        </Button1>
      </Col>

    </Row>
  );
}
